import { useMemo } from 'react';

import { FullProject } from 'entities';

import { createExternalStore } from 'providers/createStore';

// Eval changing to Map()
type ProjectMap = Record<string, FullProject>;

let projects: ProjectMap = {};

export const { useProjectById, useProjects, ...projectActions } = createExternalStore({
  actions: {
    updateProject: (
      id: string,
      updater: Partial<FullProject> | ((old: FullProject) => FullProject),
    ) => {
      const projectToUpdate = projects[id];

      const isFnUpdate = typeof updater === 'function';

      if (!projectToUpdate && !isFnUpdate) return;

      const updated = isFnUpdate ? updater(projectToUpdate) : { ...projectToUpdate, ...updater };

      projects = {
        ...projects,
        [id]: updated,
      };
    },

    setProjects(updater: (old: ProjectMap) => ProjectMap) {
      projects = updater(projects);
    },
  },

  selectors: {
    projectById(id: string) {
      return projects[id];
    },

    projects() {
      return projects;
    },
  },
});

export function useProjectUpdate() {
  return projectActions.updateProject;
}

export function useSingleProject(id: string) {
  const project = useProjectById(id);

  return useMemo(() => ({ project, updateProject: projectActions.updateProject }), [project]);
}
